export const replaceCharacters = "{0}"

export const allValidationErrorCodes = {
    DEFAULT: 'DEFAULT',
}


